import { Cell, Column, Content, DialogContainer, Flex, Grid, Heading, IllustratedMessage, Item, Link, ListBox, ProgressCircle, Row, TableBody, TableHeader, TableView, ToastQueue, useAsyncList, View } from '@adobe/react-spectrum';
import * as React from 'react';
import { useInvoiceAppType } from './Invoice.hooks';
import { useDependency } from '../../../contexts/DependencyProvider';
import { ListInvoiceRequest } from '../../../services/soap/invoice/requests/ListInvoiceRequest';
import useBrowserName from '../../../hooks/UseBrowserName';
import useScreenSize from '../../../hooks/UseScreenSize';
import { useTranslation } from 'react-i18next';
import { useViewInfo } from '../../../hooks/UseViewInfo';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../state/store';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useCallback, useEffect, useRef, useState } from 'react';
import { LayoutDefinition } from '../../../infra/protected/Layout/LayoutDefinitions';
import { useDeviceDetection } from '../../../hooks/UseDeviceDetection';
import { updateAppInfo } from '../../../state/userWebLayout/userWebLayoutSlice';
import { addKey, useKeyboardShortcuts } from '../../../hooks/UseKeyboardShortcuts';
import NotFound from '@spectrum-icons/illustrations/NotFound';
import { DeleteConfirmationDialog } from '../finder/components/DeleteConfirmationDialog';
import styles from './Invoice.module.css';
import FilterComponent from './components/FilterComponent';
import CardComponent from './components/CardComponent';
import FilterSearchTextBox from './components/FilterSearchTextBox';
import HeaderComponent from './components/HeaderComponent';
import { ListInvoiceStatusRequest } from '../../../services/soap/invoice/requests/ListInvoiceStatusRequest';
import { statusColor } from '../../../utils/helperUtil';
import { SumInvoiceRequest } from '../../../services/soap/invoice/requests/SumInvoiceRequest';
import InvoiceDetailView from './components/InvoiceDetailView';
import { GetInvoiceRequest } from '../../../services/soap/invoice/requests/GetInvoiceRequest';
import AddUpdateInvoice from './components/AddUpdateInvoice';
export interface IInvoiceProps {

}

interface Character {
  id: string;
  name: string;
}

export function Invoice(props: IInvoiceProps) {
  const { invoiceType, apiParams } = useInvoiceAppType();
  const { store, invoiceService } = useDependency();
  const browserName = useBrowserName();
  const screenSize = useScreenSize();
  const { t } = useTranslation('invoice');
  const _t = (key: string) => t(`invoice_detail.${key}`, { ns: 'invoice' });
  const _tt = (key: string) => t(`invoice_common.${key}`, { ns: 'invoice' });
  const _ttt = (key: string) => t(`invoice_table_column.${key}`, { ns: 'invoice' });

  const { isMobile } = useViewInfo();
  const dataStore = useSelector((state: any) => state.userWebLayout.appInfos);
  const selectedApp = useSelector((state: RootState) => state.userWebLayout.selectedAppId);
  const dispatch = useDispatch();
  const { state } = useLocation();
  const [showLoader, setShowLoader] = useState(true);
  const [showLoaderDetail, setShowLoaderDetail] = useState(true);
  const [rowsData, setRowsData] = useState<any>([]);
  const [columnsData, setColumnsData] = useState<any>([]);
  const [pageView, setPageView] = useState<string>('Full');
  const [selectedKeys, setSelectedKeys] = useState<Set<any>>();
  const [invoiceStatusList, setInvoiceStatusList] = useState<any>([]);
  const [definition, setDefinition] = useState<LayoutDefinition | null>(null);
  const [showMobileDetailView, setShowMobileDetailView] = useState<boolean>(false);
  const [stopLoadData, setStopLoadData] = useState<boolean>(false);
  const [searchedValue, setSearchedValue] = useState<string>('');
  const [selectedItem, setSelectedItem] = useState<any | null>(null);
  const [selectedDataRow, setSelectedDataRow] = useState<any>({});
  const serviceActivityValue = useRef<string>('');
  const queryParams = useRef<any>({ FILTER: { COL: [] } });
  const totalProductListRec = useRef<number>(0);
  const offSetLimit = useRef<number>(0);
  const dataRef = useRef<any>({});
  const [showAdd, setShowAdd] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [showRelatedCompany, setShowRelatedCompany] = useState<boolean>(false);
  const [params] = useSearchParams();
  const [showCards, setShowCards] = useState<boolean>(true);
  const [isOpen, setOpen] = useState(false);
  const deviceInfo = useDeviceDetection(isMobile);
  const [showFilter, setshowFilter] = useState<boolean>(false);
  const [sumInvoice, setSumInvoice] = useState<any>()
  const PAGE_SIZE = 50;

  useEffect(() => {
    if (state.appKey && dataStore[state.appKey]) {
      if (dataStore[state.appKey].pageView) {
        dataRef.current.pageView = dataStore[state.appKey].pageView;
        setPageView(dataStore[state.appKey].pageView);
        return;
      }
    }
  }, [dataStore.appInfos, state.appKey]);


  useEffect(() => {
    (async () => {
      if (params.has('id')) {
        setShowCards(false);
      }
      setShowLoader(true);
      setShowLoaderDetail(true);
      queryParams.current = { FILTER: { COL: [] } };
      serviceActivityValue.current = '';
      setPageView('Full');
      setSearchedValue('');
      Promise.all([getInvoiceStatusList(), getSumInvoice()]);
    })();
  }, [invoiceType]);

  useEffect(() => {
    if (selectedApp !== '') {
      invoiceList.reload();
    }
  }, [selectedApp, invoiceType]);

  useEffect(() => {
    return () => {
      dispatch(
        updateAppInfo({
          key: state.appKey,
          data: {
            pageView: dataRef.current.pageView,
          },
        })
      );
    };

  }, []);

  // React.useEffect(() => {

  //     console.log('Current Invoice Type:', invoiceType,apiParams);

  //     const result = async () => {  
  //         // Example: Fetch invoices based on the invoiceType
  //         const response = await invoiceService.listInvoices(new ListInvoiceRequest(store.Server, store.SessionId, {
  //             FILTER: apiParams,
  //             limit: 50,
  //             offset: 0,
  //         }));


  //         console.log('Fetched Invoices:', response);
  //     }

  //     result();

  // }, [invoiceType]);

  const getInvoiceStatusList = useCallback(async () => {
    const statusArray: any = [];
    let res: any = await invoiceService.listInvoiceStatus(new ListInvoiceStatusRequest(store.Server, store.SessionId, { limit: 50, offset: 0 }));
    console.table(res.ITEM);
    if (res.result === 'OK' && res.ITEM.length > 0) {
      res?.ITEM.forEach((status: any) => {
        const { id, name } = status;
        const randomNumber = Math.floor(Math.random() * 16777215) + 1;
        const colorString = statusColor(randomNumber.toString());
        statusArray.push({ id, name, color: colorString });
      });

      statusArray.unshift({ id: 'Any status', name: '', color: 'black' });
      setInvoiceStatusList(statusArray);
      console.table(statusArray);
      return statusArray;
    }
  }, [selectedApp]);

  const mapFiltersToRequest = (filters: { COL: any[] }) => {
    const requestParams: {
      orderBy?: string;
      countOnly?: boolean;
      type?: string;
      status?: string;
      refId?: string;
      manufacturer?: string;
      searchName?: string;
    } = {
      orderBy: 'name',
    };

    filters.COL.forEach(filter => {
      if (filter.name === 'contains') {
        requestParams.searchName = `${filter.value}`;
      }
      if (filter.name === 'product_code') {
        requestParams.refId = filter.value;
      }
      if (filter.name === 'manufacturer') {
        requestParams.manufacturer = filter.value;
      }
      if (filter.name === 'status') {
        requestParams.status = filter.value;
      }
      if (filter.name === 'type') {
        requestParams.type = filter.value;
      }
    });
    return requestParams;
  };

  const getSumInvoice = useCallback(async () => {
    const requestParams = mapFiltersToRequest(queryParams.current.FILTER);
    const response: any = await invoiceService.sumInvoice(new SumInvoiceRequest(store.Server, store.SessionId, {
      orderBy: 'created',
      orderBytype: 1,
      FILTER: { ...apiParams, ...requestParams }
    }))

    if (response.result === "OK") {
      console.log('response.SUMINVOICE', response.INVOICE)
      setSumInvoice(response.INVOICE)
    }
  }, [selectedApp]);

  const getInvoiceCount = async () => {

    const requestParams = mapFiltersToRequest(queryParams.current.FILTER);

    const response = await invoiceService.listInvoices(new ListInvoiceRequest(store.Server, store.SessionId, {
      FILTER: { ...apiParams, ...requestParams },
      countOnly: true,
    }));

    totalProductListRec.current = response.count || 0;

    return response.count || 0;
  }

  const loadInvoiceList = async () => {
    try {
      if (stopLoadData) {
        return rowsData;
      }
      const requestParams = mapFiltersToRequest(queryParams.current.FILTER);
      setSearchedValue('');
      const response = await invoiceService.listInvoices(new ListInvoiceRequest(store.Server, store.SessionId, {
        FILTER: { ...apiParams, ...requestParams },
        limit: PAGE_SIZE,
        offset: offSetLimit.current,
      }));

      let itemList: any[] = [];
      if (response.result === 'OK' && response?.count > 0) {
        if (Array.isArray(response.INVOICE)) {
          itemList = response.INVOICE;
        } else if (response.INVOICE) {
          itemList = [response.INVOICE];
        }

        console.log('main list products list', itemList);
        setSelectedDataRow(itemList[0])
        setSelectedItem(itemList[0])
        setSelectedKeys(new Set([itemList[0]?.id]));
        setRowsData((prev: any) => [...prev, ...itemList]);

        if (params.has('id')) {
          getLayout(+params.get('id')!);
        } else {
          if (rowsData.length === 0) { getLayout(itemList[0]?.id) }
        }

        return itemList;
      } else {
        ToastQueue.info(t('no_results', { ns: 'layout_components' }), { timeout: 50 });
        setRowsData([]);
        return [];
      }
    } finally {
      setShowLoader(false);
    }
  };

  const getLayout = async (selectedId: any) => {
    try {
      console.log('getLayout called with selectedId:', selectedId);
      const invoiceResult = await invoiceService.getInvoice(new GetInvoiceRequest(store.Server, store.SessionId, { id: selectedId }));
      if (invoiceResult.result === 'OK') {
        const invoice = invoiceResult.INVOICE;
        let result = null;
        if (Array.isArray(invoice)) {
          result = invoice.length > 0 ? extractSingleObject(invoice[0]) : null;
        } else {
          result = invoice;
        }

        setSelectedDataRow(result);
        setSelectedItem(result);
        setSelectedKeys(new Set([result.id]));
        setShowLoaderDetail(false);
        console.log(invoiceResult)
        return result;
      }
    } catch (err) {
      console.error('getlayout error: ', err);
    } finally {
      setShowLoaderDetail(false);
    }
  };

  const invoiceList = useAsyncList<Character>({
    async load({ cursor, signal }) {
      try {
        if (!selectedApp) {
          return { items: [], cursor: undefined };
        }

        const currentPage = cursor ? parseInt(cursor, 10) : 0;
        const estimatedLoadedCount = currentPage * PAGE_SIZE;
        if (cursor && estimatedLoadedCount >= totalProductListRec.current) {
          return { items: rowsData, cursor: undefined };
        }
        const totalRecords = currentPage === 0 ? await getInvoiceCount() : totalProductListRec.current;

        if (signal?.aborted) {
          console.log('Request was aborted');
        }
        const offset = Math.min(PAGE_SIZE * currentPage, totalRecords ?? 0);

        offSetLimit.current = offset;

        const items: any = await loadInvoiceList();
        const hasMoreItems = offset + (items?.length || 0) < (totalRecords ?? 0);
        const nextCursor = hasMoreItems ? String(currentPage + 1) : undefined;

        return {
          items: items || [],
          cursor: nextCursor,
        };
      } catch (error) {
        console.error('Error loading activity list:', error);
        ToastQueue.negative(t('error_loading_data', { ns: 'layout_components' }) || 'Error loading data', { timeout: 3000 });
        return { items: [], cursor: undefined };
      } finally {
        setShowLoader(false);
        setshowFilter(true);
      }
    },
    async sort({ items, sortDescriptor }) {
      if (!sortDescriptor) return { items };
      const { column, direction } = sortDescriptor;
      return {
        items: [...items].sort((a: any, b: any) => {
          const aValue = a[column];
          const bValue = b[column];

          let result = 0;
          if (typeof aValue === 'string' && typeof bValue === 'string') {
            result = aValue.localeCompare(bValue);
          } else if (aValue < bValue) {
            result = -1;
          } else if (aValue > bValue) {
            result = 1;
          }

          return direction === 'descending' ? -result : result;
        }),
      };
    },

    getKey: item => item.id,
  });

  const reloadInvoices = useCallback((filterParams: any) => {
    setStopLoadData(false);
    queryParams.current = filterParams;
    totalProductListRec.current = 0;
    offSetLimit.current = 0;
    setShowCards(true);
    invoiceList.reload();
  }, []);

  const handleTableRowClick = (rowId: any): void => {
    if (selectedKeys?.has(rowId.currentKey) || rowId === null) {
      return;
    } else {
      setShowLoaderDetail(true);
      setShowRelatedCompany(false);
      setSelectedKeys(new Set([rowId]));
      setPageView('Full');
      dataRef.current.pageView = 'Full';
      let selectedRow = rowsData.find((item: any) => item.id === rowId);
      if (!selectedRow) {
        setSelectedDataRow({});
        setSelectedKeys(undefined);
        setDefinition(null);
        return;
      }
      setSelectedDataRow(selectedRow);
      getLayout(rowId);
    }
  };

  const handleListRowClick = (rowId: any): void => {
    if (selectedKeys?.has(rowId.currentKey) || rowId.currentKey === null) {
      return;
    } else {
      setShowLoaderDetail(true);
      setShowRelatedCompany(false);
      setSelectedKeys(rowId);
      setPageView('Full');
      dataRef.current.pageView = 'Full';
      let selectedRow = rowsData.find((item: any) => item.id === rowId.currentKey);
      if (!selectedRow) {
        setSelectedDataRow({});
        setSelectedKeys(undefined);
        setDefinition(null);
        return;
      }
      setSelectedDataRow(selectedRow);
      getLayout(rowId.currentKey);
    }
  };

  const handleRowClickMobile = (rowId: any): void => {
    setShowRelatedCompany(false);
    const nameSearchExists = queryParams.current.FILTER.COL.find((col: any) => col.name === 'nameSearch');
    if (nameSearchExists) {
      setSearchedValue(nameSearchExists.value);
    }
    setSelectedKeys(undefined);
    let selectedRow = rowsData.find((item: any) => item.id === rowId.currentKey);
    if (!selectedRow) {
      setSelectedDataRow({});
      setSelectedKeys(undefined);
      setDefinition(null);
      return;
    }
    setSelectedDataRow(selectedRow);
    getLayout(rowId.currentKey);
    setShowMobileDetailView(true);
  };

  const handleViewChange = (view: string) => {
    setPageView(view);
    setShowCards(true);
    dataRef.current.pageView = view;
  };

  const getStatusColor = () => {
    if ((
      selectedItem.statusName === 'Aktivní' ||
      selectedItem.statusName === 'aktivní' ||
      selectedItem.statusName === 'active' ||
      selectedItem.statusName === 'Active')) {
      return '#1976D2';
    } else {
      return '#B0BEC5';
    }
  };

  function extractSingleObject(data: any): any {
    if (typeof data !== 'object' || data === null) {
      return null;
    }
    const keys = Object.keys(data);
    if (keys.some(key => !isNaN(Number(key)))) {
      for (const key of keys) {
        if (!isNaN(Number(key))) {
          return data[key];
        }
      }
    }
    return data;
  }

  const Loader = () => (
    <Flex width="100%" justifyContent="center" marginTop={10}>
      <ProgressCircle aria-label="Loading…" isIndeterminate />
    </Flex>
  );

  const NoResultsMessage = () => (
    <Flex direction="row" width="100%" alignContent="center" justifyContent="center">
      <IllustratedMessage>
        <NotFound />
        <Heading>{t('no_results', { ns: 'layout_components' })}</Heading>
        <Content>{t('try_another_search', { ns: 'layout_components' })}</Content>
      </IllustratedMessage>
    </Flex>
  );

  const getHeight = (baseHeight: number) => {
    if (browserName === 'Chrome') {
      return `${baseHeight - 120}px`;
    } else if (browserName === 'Safari') {
      return `${baseHeight - 120}px`;
    } else {
      return `${baseHeight - 120}px`;
    }
  };

  const getWidth = () => {
    return `95%`;
  };

  const detailStyle = {
    height: getHeight(screenSize.height - 20),
  };

  const cardStyle = {
    height: getHeight(screenSize.height),
    width: getWidth(),
    top: 0,
  };

  const filterStyle = {
    height: getHeight(screenSize.height + 60),
    overflow: 'hidden auto',
  };

  const handleAddNew = () => {
    // setShowAdd(true);
    setShowCards(false);
  };

  const handleAddNewClose = () => {
    setShowAdd(false);
    setIsEdit(false);
  };

  const handleEditClick = (data: boolean) => {
    if (data) {
      setIsEdit(data);
      setShowCards(false);
    }
  };

  const refreshDetailView = async (ProductId: any) => {
    // setShowLoaderDetail(true);
    // setSelectedKeys(new Set([ProductId]));
    // const p = await getLayout(ProductId);
    // const index = invoiceList.items.findIndex((row: any) => row.id === ProductId);
    // if (index !== -1) {
    //   invoiceList.items[index] = { ...invoiceList.items, ...p };
    // }
  };

  const handleRefreshAddNewProduct = async (ProductId: any) => {
    // setShowLoaderDetail(true);
    // setSelectedKeys(new Set([ProductId]));
    // const Product = await getLayout(ProductId);
    // const data = [...rowsData];
    // setRowsData([...data, Product]);
    // invoiceList.prepend(Product);
  };

  // const handleProductDelete = async (data: any) => {
  //   const deleteProduct = await invoiceList.deleteItem(new DeleteItemRequest(store.Server, store.SessionId, data.id, {}));
  //   if (deleteProduct.result === 'OK') {
  //     setOpen(false);
  //     ToastQueue.positive('Product deleted successfully...', { timeout: 3000 });
  //     setSelectedItem(null);
  //     setSelectedDataRow({});
  //     setSelectedKeys(undefined);
  //     invoiceList.reload();
  //   } else {
  //     ToastQueue.negative(deleteProduct.EXCEPTION.message, { timeout: 3000 });
  //   }
  // };

  useKeyboardShortcuts([...addKey('c', { ctrl: true, shift: true }, () => handleAddNew())], true);

  const shouldUseDesktopLayout = !deviceInfo.shouldUseMobileLayout() || ((deviceInfo.isTablet || deviceInfo.isIPad) && deviceInfo.orientation === 'landscape');

  const isTablet = deviceInfo.isTablet || deviceInfo.isIPad;

  const gridAreas = isTablet
    ? pageView === 'Full'
      ? (['header header', 'filter filter', 'card detail'] as any)
      : (['header header', 'filter filter', 'detail detail'] as any)
    : pageView === 'Full'
      ? (['filter header header', 'filter card detail'] as any)
      : (['filter header header', 'filter detail detail'] as any);

  // IMPORTANT: areas must match number of columns.
  // Tablet/iPad => 2 columns ALWAYS
  // Desktop     => 3 columns ALWAYS
  const gridColumns = isTablet
    ? {
      base: ['35%', '65%'],
      L: ['35%', '65%'],
    }
    : {
      base: ['245px', '28%', 'auto'],
      L: ['245px', '28%', 'auto'],
    };

  const gridRows = isTablet ? ['auto', 'auto', '1fr'] : ['auto', '1fr'];

  return (
    <>
      {!shouldUseDesktopLayout ?
        (
          <>
            {!showMobileDetailView && showCards && (
              <>
                <FilterComponent onFilterChange={reloadInvoices} filterParams={queryParams.current} sumInvoice={sumInvoice} />
                <View position={'relative'} width={'100%'} height={'100%'} UNSAFE_className={styles.card_list_parent}>
                  <Flex direction={'column'} position={'absolute'} width={'100%'} top={'72px'} left={'0%'} alignItems={'start'} justifyContent={'start'} gap={'12px'} maxHeight={'100vh'}>
                    {showLoader ? (
                      <Loader />
                    ) : (
                      <ListBox
                        id="invoiceCardsMobile"
                        selectionMode="single"
                        onSelectionChange={handleRowClickMobile}
                        onLoadMore={invoiceList.items.length > 40 ? invoiceList.loadMore : undefined}
                        marginStart={'18px'}
                        maxHeight={'100vh'}
                        minHeight={'130px'}
                        defaultSelectedKeys={selectedKeys}
                        aria-label="Cards Mobile"
                        items={invoiceList.items}
                        isLoading={invoiceList.isLoading}
                        width={'calc(100% - 32px)'}
                      >
                        {item => (
                          <Item key={item.id} textValue={item.name}>
                            <CardComponent item={item} invoiceType={invoiceType} />
                          </Item>
                        )}
                      </ListBox>
                    )}
                  </Flex>
                  <Flex
                    direction={'column'}
                    position={'absolute'}
                    width={'calc(100% - 32px)'}
                    top={'16px'}
                    right={'16px'}
                    left={'16px'}
                    alignItems={'start'}
                    justifyContent={'start'}
                    UNSAFE_className={styles.search_parent}
                  >
                    <Flex direction={'row'} alignSelf={'stretch'} height={'40px'} flexShrink={0} alignItems={'center'} justifyContent={'end'} gap={'8px'} UNSAFE_className={styles.search_field}>
                      <FilterSearchTextBox onSearchChange={reloadInvoices} filterParams={queryParams.current} serachedText={searchedValue} />
                      <i className={`${styles.icon_search} bi bi-search`}></i>
                    </Flex>
                  </Flex>
                  <Flex
                    direction={'row'}
                    position={'fixed'}
                    right={'16px'}
                    bottom={'95px'}
                    height={'48px'}
                    justifyContent={'center'}
                    alignItems={'center'}
                    gap={'8px'}
                    UNSAFE_className={styles.add_new_parent}
                  >
                    <Link onPress={handleAddNew} isQuiet aria-label="Actions" UNSAFE_className={styles.add_new_btn}>
                      <i className="bi bi-plus fs-5">
                        <View UNSAFE_className={styles.add_new_btn_text}>{_tt('button_add_new')}</View>
                      </i>
                    </Link>
                  </Flex>
                </View>
              </>
            )}

            {(showMobileDetailView || !showCards) && (
              <>
                <View id="top" position={'relative'} width={'100%'} height={'64px'} overflow={'hidden'} UNSAFE_className={styles.layout_header_parent}>
                  <Flex gap={'size-150'} position={'relative'} top={'calc(50% - 15px)'} left={'15px'} height={'30px'} UNSAFE_className={styles.layout_header_btn_back}>
                    <Link
                      onPress={() => {
                        setStopLoadData(true);
                        setShowMobileDetailView(false);
                        setShowCards(true);
                      }}
                    >
                      <i className="bi bi-chevron-left fs-5"></i>
                    </Link>
                    <span>{_t("product_details")}</span>
                  </Flex>
                </View>
                <Flex direction="column" alignItems={'start'} justifyContent={'center'} UNSAFE_className={styles.detailsHolder} UNSAFE_style={{ padding: '0px', paddingTop: '0px' }}>
                  {selectedItem && (
                    <>
                      {showLoader ? (
                        <Loader />
                      ) : (
                        <>
                          <View UNSAFE_className={styles.service_status_bar} marginBottom={'5px'} marginTop={'0px'} UNSAFE_style={{ backgroundColor: getStatusColor() }}></View>
                          {/* <ProductDetailViewMobile
                            product={selectedItem}
                            productStatusList={ProductStatusList}
                            onEdit={handleEditClick}
                            onDelete={() => setOpen(true)}
                          /> */}
                        </>
                      )}
                    </>
                  )}
                </Flex>
              </>
            )}
          </>
        ) :
        (showCards ? (
          <Grid
            areas={gridAreas}
            columns={gridColumns}
            rows={gridRows}
            height="100%"
            width="100%"
            // Avoid clipping header UI; if you MUST keep hidden, keep it but note dropdowns can clip.
            UNSAFE_style={{
              backgroundColor: '#f5f6f9',
              padding: '0px',
              margin: '0px',
              overflow: 'hidden auto',
            }}
          >
            {!(deviceInfo.isTablet || deviceInfo.isIPad) && (
              <View gridArea="filter">
                {showFilter ? (
                  <FilterComponent
                    onFilterChange={reloadInvoices}
                    filterParams={queryParams.current}
                    filterStyle={filterStyle}
                    sumInvoice={sumInvoice}
                  />
                ) : (
                  <Flex
                    height={'100%'}
                    justifyContent={'center'}
                    alignItems={'center'}
                    UNSAFE_style={{ backgroundColor: 'white' }}
                  >
                    <Loader />
                  </Flex>
                )}
              </View>
            )}

            {/* ✅ Header: removed height:'100%' which can collapse on auto rows in some mid widths */}
            <View width={'100%'} gridArea="header">
              <HeaderComponent
                onPageViewChange={handleViewChange}
                autoChanged={pageView}
                filterParams={queryParams.current}
                onSearchChange={reloadInvoices}
                fpaTypeCategory={serviceActivityValue.current}
                onAddNew={handleAddNew}
              />
            </View>

            {(deviceInfo.isTablet || deviceInfo.isIPad) && (
              <View
                gridArea="filter"
                UNSAFE_style={{
                  height: '60px',
                  backgroundColor: 'white',
                  borderBottom: '1px solid #e0e0e0',
                }}
              >
                <FilterComponent
                  onFilterChange={reloadInvoices}
                  filterParams={queryParams.current}
                  filterStyle={filterStyle}
                  sumInvoice={sumInvoice}
                />
              </View>
            )}

            {pageView == 'Full' ? (
              <>
                {showLoader ? (
                  <Loader />
                ) : (
                  <>
                    <View gridArea="card" UNSAFE_style={{ backgroundColor: '#f5f6f9', overflow: 'auto' }}>
                      {rowsData?.length > 0 ? (
                        <ListBox
                          autoFocus
                          id="invoiceCards"
                          selectionMode="single"
                          onSelectionChange={handleListRowClick}
                          onLoadMore={invoiceList.items.length > 45 ? invoiceList.loadMore : undefined}
                          marginStart={'15px'}
                          minHeight={'130px'}
                          defaultSelectedKeys={selectedKeys}
                          selectedKeys={selectedKeys}
                          aria-label="Product Cards"
                          items={invoiceList.items}
                          isLoading={invoiceList.isLoading}
                          UNSAFE_style={{ ...cardStyle, marginTop: 13 }}
                        >
                          {(item) => (
                            <Item key={item.id} textValue={item.name}>
                              <CardComponent item={item} invoiceType={invoiceType} />
                            </Item>
                          )}
                        </ListBox>
                      ) : (
                        <View marginTop={'13px'}>
                          <NoResultsMessage />
                        </View>
                      )}
                    </View>

                    <View
                      gridArea="detail"
                      backgroundColor={'static-white'}
                      borderRadius={'large'}
                      padding={'size-100'}
                      paddingTop={'0'}
                      marginTop={'17px'}
                      UNSAFE_style={detailStyle}
                      width={'98%'}
                      UNSAFE_className={styles.detailView}
                    >
                      {showLoaderDetail ? (
                        <Loader />
                      ) : (
                        <View
                          height="100%"
                          UNSAFE_className={styles.detailsHolder}
                          UNSAFE_style={{ overflow: 'hidden auto' }}
                          marginStart={'10px'}
                        >
                          {selectedItem && (
                            <>
                              {rowsData?.length > 0 ? (
                                <>
                                  <View
                                    UNSAFE_className={styles.service_status_bar}
                                    UNSAFE_style={{ backgroundColor: getStatusColor() }}
                                  />
                                  <View height={'2px'}>&nbsp;</View>
                                  <InvoiceDetailView
                                    selectedInvoice={selectedItem}
                                    invoiceStatusList={invoiceStatusList}
                                    onEdit={handleEditClick}
                                    onDelete={() => setOpen(true)}
                                    invoiceType={invoiceType}
                                  />
                                </>
                              ) : (
                                ''
                              )}
                            </>
                          )}
                        </View>
                      )}
                    </View>
                  </>
                )}
              </>
            ) : (
              <View gridArea="detail">
                {showLoader ? (
                  <Loader />
                ) : (
                  <View
                    position={'relative'}
                    overflow={'auto'}
                    height={'100%'}
                    width={'100%'}
                    UNSAFE_className={styles.service_activities}
                  >
                    {columnsData?.length > 0 && rowsData?.length > 0 ? (
                      <TableView
                        UNSAFE_className="tblLayoutComponent"
                        aria-label="Products"
                        selectionMode="single"
                        defaultSelectedKeys={selectedKeys}
                        selectionStyle="highlight"
                        width={{ base: '100%', L: '100%', M: '1100px' }}
                        minHeight={'100px'}
                        maxHeight={{ base: '100vh', L: '625px' }}
                        onAction={handleTableRowClick}
                      >
                        <TableHeader columns={columnsData}>
                          {(column: any) => (
                            <Column showDivider key={column.key} align={column.key === 'amount' ? 'end' : undefined}>
                              {column.name}
                            </Column>
                          )}
                        </TableHeader>

                        <TableBody
                          onLoadMore={invoiceList.items.length > 45 ? invoiceList.loadMore : undefined}
                          items={invoiceList.items}
                          loadingState={invoiceList.loadingState}
                        >
                          {(item: any) => (
                            <Row>
                              {(columnKey) => (
                                <Cell>
                                  {(() => {
                                    if (columnKey === 'amount') {
                                      return item[columnKey] && item[columnKey] > 0
                                        ? `${item[columnKey]} ${item['currencyName'] ? item['currencyName'] : ''}`
                                        : '0.00';
                                    } else {
                                      return item[columnKey];
                                    }
                                  })()}
                                </Cell>
                              )}
                            </Row>
                          )}
                        </TableBody>
                      </TableView>
                    ) : (
                      <NoResultsMessage />
                    )}
                  </View>
                )}
              </View>
            )}
          </Grid>
        ) : (
          <Grid
            areas={pageView == 'Full' ? ['detail', 'detail'] : ['detail', 'detail']}
            columns={{ base: ['100%'], L: ['100%'] }}
            rows={['auto', '1fr']}
            width="100%"
            UNSAFE_style={{
              backgroundColor: '#f5f6f9',
              padding: '10px',
              margin: '0px',
              overflow: 'hidden',
              boxShadow: '1px 1px 24px 0 rgba(38, 50, 56, 0.04)',
            }}
          >
            {pageView == 'Full' ? (
              <>
                {showLoader ? (
                  <Loader />
                ) : (
                  <>
                    <View
                      gridArea="detail"
                      backgroundColor={'static-white'}
                      borderRadius={'large'}
                      UNSAFE_style={{ boxShadow: '1px 1px 24px 0 rgba(38, 50, 56, 0.04)' }}
                      width={'100%'}
                      UNSAFE_className={styles.detailView}
                    >
                      {showLoaderDetail ? (
                        <Loader />
                      ) : (
                        <View UNSAFE_className={styles.detailsHolder} UNSAFE_style={{ overflow: 'hidden auto' }} marginStart={'0px'}>
                          {selectedItem && (
                            <>
                              {rowsData?.length > 0 ? (
                                <>
                                  <View height={'2px'}>&nbsp;</View>
                                  <AddUpdateInvoice
                                    selectedInvoice={selectedItem}
                                    isEdit={isEdit}
                                    invoiceType={invoiceType}
                                    handleBackClick={() => setShowCards(true)}
                                  />
                                </>
                              ) : (
                                ''
                              )}
                            </>
                          )}
                        </View>
                      )}
                    </View>
                  </>
                )}
              </>
            ) : (
              <View gridArea="detail">
                {showLoader ? (
                  <Loader />
                ) : (
                  <View position={'relative'} overflow={'auto'} height={'100%'} width={'100%'} UNSAFE_className={styles.service_activities}>
                    {columnsData?.length > 0 && rowsData?.length > 0 ? (
                      <TableView
                        UNSAFE_className="tblLayoutComponent"
                        aria-label="Products"
                        selectionMode="single"
                        defaultSelectedKeys={selectedKeys}
                        selectionStyle="highlight"
                        width={{ base: '100%', L: '100%', M: '1100px' }}
                        minHeight={'100px'}
                        maxHeight={{ base: '100vh', L: '625px' }}
                        onAction={handleTableRowClick}
                      >
                        <TableHeader columns={columnsData}>
                          {(column: any) => (
                            <Column showDivider key={column.key} align={column.key === 'amount' ? 'end' : undefined}>
                              {column.name}
                            </Column>
                          )}
                        </TableHeader>
                        <TableBody
                          onLoadMore={invoiceList.items.length > 45 ? invoiceList.loadMore : undefined}
                          items={invoiceList.items}
                          loadingState={invoiceList.loadingState}
                        >
                          {(item: any) => (
                            <Row>
                              {columnKey => (
                                <Cell>
                                  {(() => {
                                    if (columnKey === 'amount') {
                                      return item[columnKey] && item[columnKey] > 0
                                        ? `${item[columnKey]} ${item['currencyName'] ? item['currencyName'] : ''}`
                                        : '0.00';
                                    } else {
                                      return item[columnKey];
                                    }
                                  })()}
                                </Cell>
                              )}
                            </Row>
                          )}
                        </TableBody>
                      </TableView>
                    ) : (
                      <NoResultsMessage />
                    )}
                  </View>
                )}
              </View>
            )}
          </Grid>
        )
        )
      }
      {/* <DialogContainer onDismiss={handleAddNewClose}>
        {showAdd && <AddUpdateInvoice
          invoice={selectedItem}
          isEdit={isEdit}
          onClose={handleAddNewClose}
          refreshDetailView={refreshDetailView}
          handleRefreshAddNewProduct={handleRefreshAddNewProduct}
          invoiceType={invoiceType} />
        }
      </DialogContainer> */}
      <DeleteConfirmationDialog
        isOpen={isOpen}
        onClose={() => setOpen(false)}
        onConfirm={() => {
          // handleProductDelete(selectedItem);
        }}
        itemName={selectedItem?.name}
      />
    </>
  );
}
